Vendd.Scripts.load(function () {
    'use strict';

    var $wrappers = $('.x-order-details-expandable.all-orders');
    if ($wrappers.length < 1) return;

    var model = null, translatorsObject = $('.order-list-container').data('translators');

    $wrappers.each(function (i, wrapper) {
        var $wrapper = $(wrapper);
        var wrapper = $wrapper.get(0);
        var orderId = $wrapper.data('order-code');
        var initLoading = false;

        var $loadingIndicator = $('.details-loading-indicator', $wrapper);
        var $loadingError = $('.details-loading-error', $wrapper);

        wrapper.loading = function loading(loading, error) {
            if (loading && initLoading) {
                return false;
            }

            initLoading = loading;

            if (loading) {
                $loadingIndicator.addClass('visible');
                $loadingError.removeClass('visible');
            } else {
                $loadingIndicator.removeClass('visible');
                if (error) {
                    $loadingError.addClass('visible');
                } else {
                    $loadingError.removeClass('visible');
                }
            }

            return true;
        };

        wrapper.showLoader = function (loader) {
            var $cont = $wrapper.closest('.x-all-orders-order');

            if (loader === true) {
                $cont.addClass('x-loading');
            } else {
                $cont.removeClass('x-loading');
            }
        };

        wrapper.init = function () {
            if (!wrapper.loading(true) || $wrapper.hasClass('already-binded'))
                return;

            wrapper.showLoader(true);
            Vendd.MessageBus.publishAsync(wrapper, new Vendd.AllOrdersHistory.Messages.GetOrderItems(orderId));
        };

        wrapper.update = function () {
            var html = Vendd.Handlebars.parse("accountAllOrdersOrderBoxDetails_A", model);
            wrapper.bind(html);

            wrapper.loading(false);
            wrapper.showLoader(false);
        };

        wrapper.bind = function bind(html) {
            $('.order-products', $wrapper).html(html);

            $wrapper.addClass('already-binded');

            initDetails($wrapper, orderId);
        };

        $('.retry-details-loading-button', $wrapper).on('click', function () {
            wrapper.bind('');
            Vendd.MessageBus.publishAsync(wrapper, new Vendd.AllOrdersHistory.Messages.GetOrderItems(orderId));
        });
    });

    Vendd.MessageBus.subscribe(Vendd.AllOrdersHistory.Messages.GetOrderItemsSuccess, 'x-all-order-details-expandable', function (envelope) {
        model = envelope.message.data;
        model.translators = translatorsObject;

        //prevent reorder for inquiry products
        model.data.Items.forEach(function (product) {
            if (product.AvailabilityAction && product.AvailabilityAction.AvailabilityActionId && product.AvailabilityAction.AvailabilityActionId == 7) {
                product.CanReOrderItem = false;
                product.AvailabilityAction.CanBuy = false;
            }
        });

        var wrapper = envelope.sender;
        if (wrapper) wrapper.update();
    });

    Vendd.MessageBus.subscribe(Vendd.AllOrdersHistory.Messages.GetOrderItemsFailure, 'x-all-order-details-expandable', function (envelope) {
        var wrapper = envelope.sender;
        var response = envelope.message.data;

        if (wrapper) {
            console.log('Failed to load order details:', response);

            wrapper.loading(false, true);
            wrapper.showLoader(false);
        }
    });

    function initDetails($box, orderId) {
        var $items = $('[data-type="product"]', $box);
        var itemsCount = $('[data-type="product"][data-can-buy="true"]', $box).length;
        var selectItems = $('[data-type="reOrderCheck"]:checked', $box).length;
        var canBuy = false;

        $items.each(function (index) {
            if ($(this).data('canBuy') === "True" || $(this).data('canBuy') === "true" || $(this).data('canBuy') === true) {
                canBuy = true;
            }
        });

        if (canBuy === false) {
            $('.reorder-container .checkbox-wrapper', $box).addClass('disabled');
            $('.reorder-container .checkbox-wrapper input', $box).attr('disabled', 'disabled');
            $('.reorder-container .add-all-to-cart', $box).addClass('disabled');
        }

        $box.on('click', '*[data-click="add-all-to-cart"]', function (e) {
            e.preventDefault();

            if ($(this).hasClass('disabled'))
                return;

            $(".no-items-error", $box).hide();

            if (selectItems > 0) {
                Vendd.MessageBus.publish($box, new Vendd.Order.Messages.AddAllToCart({ orderId: orderId, orderItemsToAdd: getSelectedOrderItems($box) }));
            } else {
                $(".no-items-error", $box).show();
            }
        });

        $box.on('change', '[data-click="select-all"]', function () {
            if ($(this).is(':checked')) {
                $.each($('[data-type="reOrderCheck"]', $box), function (index, checkbox) {
                    if ($(checkbox).not(':disabled').length > 0) {
                        $(checkbox).prop('checked', true);
                        selectItems = selectItems + 1;
                    }
                });

                if (selectItems) $(".no-items-error").hide();
            } else {
                $('[data-type="reOrderCheck"]', $box).prop('checked', false);
                selectItems = 0;
            }
        });

        $box.on('change', '[data-type="reOrderCheck"]', function () {
            if ($(this).is(':checked')) {
                selectItems++;
                $(".no-items-error").hide();
                if (selectItems === itemsCount) {
                    $('[data-click="select-all"]', $box).prop('checked', true);
                }
            } else {
                selectItems--;
                $('[data-click="select-all"]', $box).prop('checked', false);
            }
        });

        $box.on('click', '.qty-button', function (e) {

            if ($(this).closest('.x-reorder-spinner').hasClass('disabled'))
                return;

            var $this = $(this),
                $item = $this.closest('.reorder-item');

            var $spinner, $input, val, min, max, step;

            $this = $(this);
            $spinner = $this.parent();
            $input = $this.siblings('input[name="qty"]').eq(0);
            val = parseInt($input.val());

            min = stringToNumber($(this).closest("li").attr("data-min-quantity"));
            max = stringToNumber($(this).closest("li").attr("data-max-quantity"));
            step = stringToNumber($(this).closest("li").attr("data-quanta"));

            if (isNaN(val) || val <= 0) val = 1;
            if (isNaN(min) || min <= 0) min = 1;
            if (isNaN(max) || max <= 0) max = 999;
            if (isNaN(step) || step <= 0) step = 1;

            var qty = stringToNumber($('input[name="qty"]', $item).val());

            if ($this.hasClass('decr') && qty > parseFloat(step)) {

                if (Vendd.Helpers.isInteger(parseFloat(step))) {
                    qty = parseInt(qty) - parseInt(step);
                } else if (parseFloat(qty) > parseFloat(min) && (parseFloat(qty) - parseFloat(step) >= parseFloat(min))) {
                    qty = parseFloat(qty) - parseFloat(step);
                    qty = parseFloat(qty).toFixed(2);
                }

                $('input[name="qty"]', $item).val(numberToString(qty, false, true));
                $this.siblings('.js-increment').removeClass('disabled');
                $this.siblings('.js-increment').removeAttr('disabled');

                if (qty === min || qty === max) {
                    $this.addClass('disabled');
                    $this.attr('disabled', 'disabled');
                }
                $('.qty-button.incr', $box).removeClass('disabled');
                $('.qty-button.incr', $box).removeAttr('disabled');
            }
            else if ($this.hasClass('incr') && qty < parseFloat(max)) {

                if (Vendd.Helpers.isInteger(parseFloat(step))) {
                    qty = parseInt(qty) + parseInt(step);
                } else if (parseFloat(qty) < parseFloat((max == null || max === "" ? 1000000 : max)) && (parseFloat(qty) + parseFloat(step)) <= parseFloat((max == null || max === "" ? 1000000 : max))) {
                    qty = parseFloat(qty) + parseFloat(step);
                    qty = parseFloat(qty).toFixed(2);
                }

                $('input[name="qty"]', $item).val(numberToString(qty, false, true));

                $this.siblings('.js-decrement').removeClass('disabled');
                $this.siblings('.js-decrement').removeAttr('disabled');

                if (qty === min || qty === max) {
                    $this.addClass('disabled');
                    $this.attr('disabled', 'disabled');
                }
                $('.qty-button.decr', $box).removeClass('disabled');
                $('.qty-button.decr', $box).removeAttr('disabled');
            }
        });

        $box.on('click', '.js-expand-combo', function () {
            $(this).closest('.order-product-item').siblings().find('.combo-item-wrapper.expanded').removeClass('expanded open-above').children('.combo-title').removeClass('icon-arrow-up').addClass('icon-arrow-down');

            if ($(this).closest('.order-product-item').index() >= ($items.length - 2) && $items.length > 3) {
                $(this).parent().toggleClass('open-above');
            }

            $(this).parent().toggleClass('expanded');
            $(this).toggleClass('icon-arrow-down icon-arrow-up');
        });
    }

    function getSelectedOrderItems($wrapper) {
        var OrderItemsToAdd = [];
        $('[data-type="reOrderItem"]', $wrapper).each(function () {
            if (($('[data-type="reOrderCheck"]', this).is(":checked"))) {
                var reOrderItem = {
                    ProductId: $(this).attr('data-productid'),
                    SkuId: $(this).attr('data-skuid'),
                    Quantity: $('[data-type="reOrderQuantity"]', this).val()
                };
                OrderItemsToAdd.push(reOrderItem);
            }
        });

        return OrderItemsToAdd;
    }

});